const register = {
  loginCredentials: "Kelayakan Log Masuk", // translated 
  companyInformation: "Maklumat Syarikat", // translated 
  contactDetails: "Butiran Perhubungan", // translated 
  businessName: "Nama Perniagaan", // translated 
  businessAddress: "Alamat Perniagaan", // translated 
  registrationCode: "Kod Pendaftaran", // translated 
  businessRegistrationNumber: "Nombor Pendaftaran Perniagaan", // translated 
  websiteUrl: "URL Laman Web", // translated 
  mobilePhone: "Telefon Bimbit", // translated 
  regionStateProvince: "Wilayah/Negeri/Wilayah", // translated 
  legalTitle: "Hak Milik Undang-undang", // translated 
  city: "Bandar", // translated 
  postalCode: "Poskod", // translated 
  registrationSuccess: "Kejayaan Pendaftaran.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Sila tunggu beberapa ketika dan anda akan dialihkan ke halaman utama.", // translated 
  usernameEmail: "Nama Pengguna (Emel)", // translated 
  password: "Kata Laluan", // translated 
  verifyPassword: "Sahkan Kata Laluan", // translated 
  documents: "Dokumen", // translated 
  termsAndConditionsSection: "Terma & Syarat", // translated 
  certificateOfIncorporation: "Sijil Pemerbadanan", // translated 
  acceptTermsAndConditions: "Terima Terma & Syarat", // translated 
  country: "Negara", // translated 
  brandName: "Nama Jenama", // translated 
  register: "Daftar", // translated 
  isRequired: "Diperlukan", // translated 
  passwordMin8Chars: "Mesti mempunyai sekurang-kurangnya 8 aksara", // translated 
  passwordRequiresDigit: "Mesti mengandungi sekurang-kurangnya 1 digit", // translated 
  passwordRequiresLowercase: "Mesti mengandungi sekurang-kurangnya 1 huruf kecil", // translated 
  passwordRequiresUppercase: "Mesti mengandungi sekurang-kurangnya 1 huruf besar", // translated 
  passwordRequiresSpecialChar: 'Mesti mengandungi sekurang-kurangnya 1 aksara khas(!@#$%^&*(),.?":{}|<>)', // translated 
  uploadFile: "Muat Naik Fail", // translated 
  filename: "Nama fail:", // translated 
  fileType: "Jenis:", // translated 
  fileSize: "Saiz:", // translated 
  maxFileSize10Mb: "Maks: 10MB", // translated 
  supportedFileTypes: "Jenis fail yang disokong:", // translated 
  showPassword: "Tunjukkan kata laluan", // translated 
  hidePassword: "Sembunyikan kata laluan", // translated 
  notAvailable: "Tidak Ada", // translated 
  fileSizeInKb: "{{saiz}} KB", // translated 
  mobilePhonePlaceholder: "cth. +12025550123", // translated 
  websiteUrlPlaceholder: "http://www.example.com", // translated 
  loading: "Memuatkan...", // translated 
  uploadingDocument: "Memuat naik dokumen...", // translated 
  percentUploaded: "{{percent}}% dimuat naik", // translated 
  registrationSuccessful: "Pendaftaran berjaya.", // translated 
  failedToUploadDocument: "Gagal memuat naik dokumen.", // translated 
  fieldIsRequired: "{{medan}} {{diperlukan}}", // translated 
  fieldMinLength: "{{field}} mesti lebih panjang daripada {{min}} aksara", // translated 
  fieldMustBeValidEmail: "{{field}} mestilah e-mel yang sah", // translated 
  fieldPasswordMinLength: "{{field}} mesti mempunyai sekurang-kurangnya 8 aksara", // translated 
  fieldPasswordRequiresDigit: "{{field}} mesti mengandungi sekurang-kurangnya 1 digit", // translated 
  fieldPasswordRequiresLowercase: "{{field}} mesti mengandungi sekurang-kurangnya 1 huruf kecil", // translated 
  fieldPasswordRequiresUppercase: "{{field}} mesti mengandungi sekurang-kurangnya 1 huruf besar", // translated 
  fieldPasswordRequiresSpecialChar:
    '{{field}} mesti mengandungi sekurang-kurangnya 1 aksara khas (!@#$%^&*(),.?":{}|<>)', // translated 
  passwordsDoNotMatch: "{{field}} tidak sepadan dengan {{otherField}}", // translated 
  fieldBetweenLength: "{{field}} mesti berada di antara {{min}} dan {{max}} aksara", // translated 
  postalCodeBetweenLength: "Kod {{field}} mesti berada di antara aksara {{min}} dan {{max}}", // translated 
  invalidUrlFormat: "Format URL tidak sah", // translated 
  invalidEmailFormat: "Format e-mel tidak sah", // translated 
  emailMustMatchUsername: "emel mestilah sama dengan nama pengguna (emel)", // translated 
  mobilePhoneIsRequired: "Telefon bimbit diperlukan", // translated 
  certificateFileTooLarge: "Fail Sijil terlalu besar", // translated 
  termsMustBeAccepted: "Terma & Syarat mesti diterima", // translated 
};






export default register;
